import { cn } from 'cn';
import type { MDXComponents, MDXProps } from 'mdx/types';
import type * as React from 'react';

import { localizeHref } from '@/paraglide/runtime';

interface MarkdownProps {
  body: React.FC<MDXProps>;
  className?: string;
  components?: MDXComponents;
}

/** Keeps a link to another page of the site in the reader's language; other links pass through. */
function SiteLink({ href, ...props }: React.ComponentProps<'a'>) {
  const local = href !== undefined && href.startsWith('/') && !href.startsWith('//');
  return <a href={local ? localizeHref(href) : href} {...props} />;
}

export function MarkdownDocs({ body: Mdx, className, components }: MarkdownProps) {
  return (
    <div
      className={cn('prose prose-a:underline-offset-4 prose-a:hover:text-brand max-w-none', className)}
      data-mdx-content
    >
      <Mdx components={{ a: SiteLink, ...components }} />
    </div>
  );
}
